<template>
  <main class="content container">
    <div class="content__top">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link" href="index.html">
            Каталог
          </a>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link">
            Корзина
          </a>
        </li>
      </ul>
      <div class="content__row">
        <h1 class="content__title">
        Страница не найдена.
      </h1>
      <span class="content__info">
        К сожалению данной страницы не существует, проверьте, верно ли введена ссылка.
      </span>
      </div>
    </div>
  </main>
</template>
<script>
export default {
};
</script>
